import { ValidationService, type ValidatableElement } from "aspnet-client-validation";

const validationService = new ValidationService();
const defaultHighlight = validationService.highlight.bind(validationService);
const defaultUnhighlight = validationService.unhighlight.bind(validationService);

validationService.highlight = (input, errorClass, validClass): void => {
    defaultHighlight(input, errorClass, validClass);
    input.setAttribute("aria-invalid", "true");
};

validationService.unhighlight = (input, errorClass, validClass): void => {
    defaultUnhighlight(input, errorClass, validClass);
    input.removeAttribute("aria-invalid");
};

function connectValidationMessages(root: ParentNode): void {
    const messages = root.querySelectorAll<HTMLElement>("[data-valmsg-for]");
    for (const message of messages) {
        const fieldName = message.dataset.valmsgFor;
        if (!fieldName) {
            continue;
        }

        const form = message.closest("form");
        const candidates = form?.querySelectorAll<ValidatableElement>("input[name], select[name], textarea[name]");
        const input = Array.from(candidates || []).find(candidate => candidate.name === fieldName);
        if (!input) {
            continue;
        }

        if (!message.id) {
            message.id = `${input.id || fieldName.replace(/[^a-zA-Z0-9_-]/g, "-")}-validation`;
        }

        const describedBy = new Set((input.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean));
        describedBy.add(message.id);
        input.setAttribute("aria-describedby", Array.from(describedBy).join(" "));
    }
}

connectValidationMessages(document);
validationService.bootstrap({ watch: true });

const validationMessageObserver = new MutationObserver(records => {
    for (const record of records) {
        for (const node of record.addedNodes) {
            if (node instanceof HTMLElement) {
                connectValidationMessages(node);
            }
        }
    }
});

validationMessageObserver.observe(document.body, { childList: true, subtree: true });
